import Flex from '~/common/components/Flex';

type Loan1003FormBuilderWrapperProps = {
  children: React.ReactNode;
  customPadding?: string;
};

export default function Loan1003FormBuilderWrapper({
  children,
  customPadding,
}: Readonly<Loan1003FormBuilderWrapperProps>) {
  return (
    <Flex
      flexDirection="column"
      width="100%"
      padding={customPadding || '0 1.5rem'}
    >
      {children}
    </Flex>
  );
}
